import { useQuery } from "@tanstack/react-query";
import categoryService from "../../services/items/categories/category.service";

// 0015: the SINGLE fetch of the category nav list (getAll). NOT auth-gated — categories render for
// anonymous visitors (home, footer, header nav). React Query dedups consumers + StrictMode to ONE
// network call. staleTime 5 min — categories are near-static.
const useCategoriesQuery = () =>
  useQuery({
    queryKey: ["categories", "all"],
    queryFn: () => categoryService.getCategories({ getAll: true }).then((r) => r.data.payload),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

export default useCategoriesQuery;
